import { render, staticRenderFns } from "./NewSolutions.vue?vue&type=template&id=7f2f5b61&scoped=true&"
import script from "./NewSolutions.vue?vue&type=script&lang=js&"
export * from "./NewSolutions.vue?vue&type=script&lang=js&"
import style0 from "./NewSolutions.vue?vue&type=style&index=0&id=7f2f5b61&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2f5b61",
  null
  
)

export default component.exports